<template>
  <div class="content">
    <div class="tra-content">
      <div class="itemCard clearfix" v-for="(item, i) in list" :key="i">
        <div class="pic">
          <img :src="item.img" v-if="item.img" alt="" />
          <img :src="item.videoImg" v-else-if="item.videoImg" alt="" />
          <div class="play-btn" v-if="item.videoImg || item.videoUrl || item.type == 14"></div>
          <!-- 系列视频 -->
          <img src="@static/images/product/articelListTag.png" class="pic-tag" v-if="item.type == 14" />
        </div>
        <div class="content">
          <div class="title" @click="getDetail(item)">
            {{ item.title }}
          </div>
          <div class="desc" ref="desc" v-if="item.summary">
            {{ item.summary }}
          </div>
          <div class="tag">
            <div class="tag-body" v-for="(label, ii) in item.label" :key="ii">
              <span class="tagItem">{{ label }}</span>
            </div>
          </div>
          <!-- 直播分类，且文章类型不是系列视频 -->
          <div class="timeAnum" v-if="type == 4 && item.type != 14">
            <div>
              <span class="label">开课时间：</span><span class="value">{{ item.beginclassDate | timeNum(16) }}</span>
            </div>
            <div v-if="item.duration">
              <span class="label">时长：</span><span class="value">{{ item.duration || 0 }}</span>
            </div>
          </div>
          <div class="timeAnum" v-else>
            <div>
              <span class="label">更新时间：</span><span class="value">{{ item.updateTime | timeNum(10) }}</span>
            </div>
            <div>
              <span class="label">阅读次数：</span><span class="value">{{ item.readNumber || 0 }}</span>
            </div>
          </div>
        </div>
        <div class="btn">
          <el-button class="ckxqbtn" type="primary" @click="getDetail(item)" plain>查看详情</el-button>
          <el-button class="xzkjbtn" type="primary" plain v-if="item.isHasCourseware == 1 && (item.type == 4 || item.type == 14)" @click="download(item)">下载课件</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: null,
    type: null
  },
  data: () => ({
    descc: '一款宠物犬主的专属责任保障，保障被保险人合法饲养的犬造成第三者人身伤害带来的赔偿责任，包括人身伤亡赔偿和医疗费用赔偿。',
    src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
  }),
  components: {},
  created() {},
  methods: {
    getDetail(item) {
      if (item.content || item.type == 3) {
        const rou = this.$router.resolve({
          path: '/articleDetail',
          query: {
            id: item.id,
            type: item.type
          }
        });
        window.open(rou.href, '_blank');
      } else if (item.type == 14) {
        const rou = this.$router.resolve({
          path: '/cloudCollege/seriesVideo',
          query: {
            id: item.id
          }
        });
        window.open(rou.href);
      } else if (item.type == 4 && item.videoUrl) {
        window.open(item.videoUrl);
      } else {
        this.$notice.alert('打开失败');
      }
    },
    download(item) {
      const list = [
        {
          type: 3,
          articleId: item.id
        }
      ];
      this.$tools.daochu('/master/information/downloadFile', { list }, 'put');
    }
  }
};
</script>
<style lang="scss" scoped>
@import './articleList';
</style>
